/**
 * Paths and titles for the legal pages, kept separate from `legal.js`.
 *
 * The header, footer and router only need to know these routes exist. Keeping
 * them here means linking to a legal page does not pull the full text of both
 * documents into the main bundle — that content is code-split and only fetched
 * when someone actually opens one.
 */

export const PRIVACY_PATH = '/privacy-policy';
export const TERMS_PATH = '/terms-and-conditions';

export const legalLinks = [
  { slug: 'privacy', path: PRIVACY_PATH, title: 'Privacy Policy' },
  { slug: 'terms', path: TERMS_PATH, title: 'Terms & Conditions' },
];

export default legalLinks;
